import React, { Component } from 'react'
import { connect } from 'redaction'
import actions from 'redux/actions'
import cx from 'classnames'
import { FormattedMessage } from 'sb-react-intl'

import messages from './messages'
import s from './ShareToggler.scss'


const buttons = [ 'facebook', 'twitter' ]

class ShareToggler extends Component {

  toggle = (key, value) => {
    const { shouldBeShared } = this.props

    actions.models.review.setShouldBeShared({
      ...shouldBeShared,
      [key]: value,
    })
  }

  render() {
    const { className, shouldBeShared } = this.props

    return (
      <div className={cx(s.container, className)}>
        <FormattedMessage className={s.title} {...messages.title} />
        {
          buttons.map((key) => {
            const isActive = shouldBeShared[key]
            const toggleWrapperClassName = cx(s.toggleWrapper, s[key], {
              [s.active]: isActive,
            })

            return (
              <div
                key={key}
                className={toggleWrapperClassName}
                onClick={() => this.toggle(key, !isActive)}
              >
                <span className={s.toggle} />
              </div>
            )
          })
        }
      </div>
    )
  }
}


export default connect({
  shouldBeShared: 'models.review.shouldBeShared',
})(ShareToggler)
